import React from 'react';

import { type VariantProps, tv } from 'tailwind-variants';

import { cn } from 'common/style/utils';

export const cardVariants = tv({
  slots: {
    base: 'base-border bg-card rounded',
  },
  variants: {
    size: {
      small: {
        base: 'p-2',
      },
      default: {
        base: 'p-3',
      },
      large: {
        base: 'p-4',
      },
      xlarge: {
        base: 'p-5',
      },
    },
    borderStyle: {
      solid: {
        base: 'border-solid',
      },
      dashed: {
        base: 'border-dashed',
      },
      dotted: {
        base: 'border-dotted',
      },
      none: {
        base: 'border-solid border-transparent',
      },
    },
  },
  defaultVariants: {
    size: 'default',
    borderStyle: 'solid',
  },
});

type CardProps = VariantProps<typeof cardVariants> & {
  className?: string;
  children: React.ReactNode;
};

const Card = ({ borderStyle, size, children, className }: CardProps) => {
  const styles = cardVariants({ borderStyle, size, className });

  return <div className={cn(styles.base({ className }))}>{children}</div>;
};

export default Card;
